import React, {useEffect, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import PercentGaugeKpi from '../../publisher/kpis/PercentGaugeKpi';
import Kpi from "../../publisher/kpis/Kpi";
import {formatNumber} from "../../Format";

const KpisContainer = styled.div`
  background: white;
  width: 100%;
  margin-bottom: 60px;
  margin-top: 60px;
  box-shadow: 0px 0px 17px #CCCCCC;
  display: flex;
`

export default function CmpAnalyticsKpis ({ data }) {
  const { t } = useTranslation();

  const computeKpis = () => {
    let { activeDevicesCount = 0, devicesWithCmpPresentedCount = 0, consentedDevicesCount = 0 } = data
    let displayRate = activeDevicesCount == 0 ? 0 : 100 * devicesWithCmpPresentedCount/activeDevicesCount
    let consentRate = devicesWithCmpPresentedCount == 0 ? 0 : 100 * consentedDevicesCount/devicesWithCmpPresentedCount
    return {
      activeDevicesCount: activeDevicesCount,
      displayRate,
      devicesWithCmpPresentedCount: devicesWithCmpPresentedCount,
      consentRate,
      consentedDevicesCount: consentedDevicesCount
    }
  }
  const { activeDevicesCount, displayRate, devicesWithCmpPresentedCount, consentRate, consentedDevicesCount } =  useMemo(
    () => {
      return computeKpis()
    },
    [ data.activeDevicesCount, data.devicesWithCmpPresentedCount, data.consentedDevicesCount]
  )

  return (
    <KpisContainer>
      <Kpi icon={'mobile'} value={formatNumber(activeDevicesCount)} title={t("cmp.analytics.kpis.devices")}/>
      <PercentGaugeKpi value={displayRate} title={t("cmp.analytics.kpis.displayRate")}/>
      <Kpi icon={'location'} value={formatNumber(devicesWithCmpPresentedCount)} title={t("cmp.analytics.kpis.devicesWithCmpPresented")} ></Kpi>
      <PercentGaugeKpi value={consentRate} title={t("cmp.analytics.kpis.consentRate")}/>
      <Kpi icon='consent' value={formatNumber(consentedDevicesCount)} title={t("cmp.analytics.kpis.consentedDevices")} ></Kpi>
    </KpisContainer>
  )
}
